<div class="container root">
  <div class="row">
    <a
      routerLink="/"
      class="col-sm tab-col"
      (click)="changeTab('/')"
      [ngClass]="{ 'active-tab': currentTab === '/' }"
      >View my Speeches</a
    >
    <a
      routerLink="/submit"
      class="col-sm tab-col tab-col-middle"
      (click)="changeTab('/submit')"
      [ngClass]="{
        'active-tab': currentTab === '/submit'
      }"
      >Submit a new Speech</a
    >
    <a
      routerLink="/search"
      class="col-sm tab-col"
      (click)="changeTab('/search')"
      [ngClass]="{
        'active-tab': currentTab === '/search'
      }"
      >Search all Speeches</a
    >
  </div>

  <router-outlet></router-outlet>
</div>
